import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';

function MediaKit() {
  return (
    <div className="page page--narrow">
      <Seo title="Media Kit" description="Media Kit de Libros para Viajeros: audiencia, servicios y colaboraciones." />
      <h1>Media Kit</h1>
      <p className="page__intro">
        Presentación, audiencia, métricas, servicios, ejemplos y formatos de colaboración. Versión descargable en
        PDF disponible próximamente.
      </p>
      <p className="empty-state">
        Pendiente de cargar métricas reales (seguidores, alcance, engagement) y el PDF descargable. Este bloque se
        actualizará sin necesidad de desarrollador una vez esté conectado al panel de administración.
      </p>
      <Link className="cta-button" to="/contacto">Solicitar Media Kit</Link>
    </div>
  );
}

export default MediaKit;
